import notification from 'antd/es/notification';
import {
  districtPolygonFilter,
  districtsFilter,
  gradientFilter,
  polygonFilter,
} from './filters.js';

export default function filterHexagons(
  hexagons,
  activeFilters,
  isochroneStore,
  showPopup = true
) {
  const filteredHexagons = hexagons.filter((item) => {
    const polygons = [...activeFilters.draw_polygon, ...isochroneStore];
    if (!gradientFilter(activeFilters, item)) return false;
    if (activeFilters.district.length > 0 && polygons.length > 0) {
      if (!districtPolygonFilter(activeFilters.district, polygons, item))
        return false;
    } else if (activeFilters.district.length > 0 || polygons.length > 0) {
      if (!districtsFilter(activeFilters, item)) return false;
      if (!polygonFilter(polygons, item)) return false;
    }
    return true;
  });

  notification.config({
    maxCount: 1,
    duration: 3,
  });

  if (filteredHexagons.length === 0 && showPopup) {
    notification.error({
      message: 'Error',
      description: 'При данной фильтрации результат 0 гексагонов',
      placement: 'topRight',
      className: 'notification',
    });

    return hexagons;
  }

  return filteredHexagons;
}
